<template>
  <div>
    <div class="mes-list">
      <div class="list-left">
        <p>修改密码</p>
        <p>设置新密码</p>
      </div>
      <el-button type="text" @click="passwordDialog = true">修改</el-button>
    </div>

    <!-- 修改密码的弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialog"
      width="50rem"
      :center="true"
      :before-close="clearPasswordDialog"
      class="dialog"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div class="password-dialog">
        <el-form
          ref="passwordForm"
          :model="passwordForm"
          :rules="passwordRules"
          label-width="12rem"
          label-suffix="："
          size="small"
        >
          <el-form-item label="当前密码" prop="currentPassword">
            <el-input
              v-model.trim="passwordForm.currentPassword"
              placeholder="请输入当前密码"
              show-password
            />
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model.trim="passwordForm.newPassword"
              placeholder="请输入新密码"
              show-password
            />
          </el-form-item>
          <el-form-item label="再次确认新密码" prop="confirmPassword">
            <el-input
              v-model.trim="passwordForm.confirmPassword"
              placeholder="请再次确认新密码"
              show-password
              @keyup.enter.native="editPassword"
              @keydown.enter.native.prevent="() => {}"
            />
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editPassword">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { editPasswordApi } from '@/api/user'
import { passwordRegularValid } from '@/utils/form-valid'

export default {
  name: 'ChangePassword',

  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      }
      callback()
    }

    return {
      // 修改密码变量
      passwordDialog: false,
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        currentPassword: [
          {
            required: true,
            message: '请输入当前密码',
            trigger: ['blur', 'change']
          }
        ],
        newPassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: ['blur', 'change']
          },
          passwordRegularValid
        ],
        confirmPassword: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: ['blur', 'change']
          },
          {
            validator: validateConfirmPassword,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },

  methods: {
    // 修改密码
    editPassword() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return

        editPasswordApi(this.passwordForm)
          .then(res => {
            this.clearPasswordDialog()
            // this.handleFunForMesChange('登录密码修改成功，请重新登录')
            this.$emit('afterChange', '登录密码修改成功，请重新登录')
          })
          .catch(err => {
            this.$message.error(err.data?.message)
          })
      })
    },

    // 关闭修改密码弹窗
    clearPasswordDialog() {
      this.passwordDialog = false
      this.passwordForm = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.$refs.passwordForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.mes-list {
  display: flex;
  align-items: center;
  margin-top: pixel-to-rem($n: 20);
  border-bottom: 1px solid $info-fourth-color;

  .list-left {
    flex: 1;
    text-align: left;

    p:first-child {
      font-size: 16px;
      margin: 10px 0;
    }
    p:last-child {
      color: $text-third-color;
    }
  }
}

.password-dialog {
  width: 80%;
  ::v-deep .el-input {
    input {
      height: 32px;
    }
  }
}
</style>
